import React from 'react';
import { connect } from 'react-redux';
import MainMenu from 'components/common/mainmenu'
import CustomStatsMenu from './customstatsmenu';

import Charts from 'components/pages/stats/charts';
import Path from "components/common/path";
import StickyMenu from "components/common/stickymenu"
export class Stats extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            currentNode: {
                info: {
                    name: "",
                    empty: true
                }
            },
            path: []
        };
    }

    componentDidMount() {
        this.prepare(this.props);
    }

    empty(node) {
        return (node.info.empty == true)
    }

    componentWillReceiveProps(nextProps) {
        this.prepare(nextProps);
    }

    prepare(props) {
        var path = [];
        var res = { currentNode: {} };
        this.findNode(props.nodeMap, props.params.id, path, res);
        this.setState({ currentNode: res.currentNode, path: path });
    }

    findNode(nodeMap, id, path, res) {
        res.currentNode = nodeMap[id]
        if (!res.currentNode) {
            res.currentNode = {};
            return;
        }
        var tmp = [], cur = res.currentNode;
        while (cur) {
            tmp.push(cur);
            cur = cur.parent;
        }
        while (tmp.length) {
            path.push(tmp[tmp.length - 1]);
            tmp.pop();
        }
    }
    render() {
        return (
            <div className="statistic-page overwrite--modal--depth">
                <StickyMenu
                    withStickyHeader={false}
                >
                    <MainMenu
                        overviewIsActive={false}
                        comparisonIsActive={false}
                        onlyLeftMenu={false}
                    />

                    <CustomStatsMenu
                        name={this.state.currentNode.info.name}
                        id={this.state.currentNode.id}
                        node={this.state.currentNode}
                        querySettings={this.props.querySettings}
                    />
                    <Path path={this.state.path} linkOn={(x) => x.info.hasfloorplan} link={(x) => "statistic/" + x.id} />
                </StickyMenu>
                <div className="page-content">
                    <Charts
                        currentNode={this.state.currentNode}
                        querySettings={this.props.querySettings}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        tree: state.overviewReducer.customerOverview,
        nodeMap: state.overviewReducer.nodeMap,
        querySettings: state.querySettingsReducer,
        cards: state.defaultSettingsReducer.card
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Stats);



// WEBPACK FOOTER //
// ./src/components/pages/stats/index.jsx